import type { User } from '@prisma/client';
import type {
	LinksFunction,
	LoaderFunctionArgs,
	MetaFunction,
} from '@remix-run/node';

import { useLoaderData } from '@remix-run/react';
import { getUser } from '~/utils/session.server.ts';

import { renderSwitch } from '~/components/organisms/PriceSwitch/index.tsx';
import { Banner } from '~/components/atoms/Banner/index.tsx';
import divider from '~/components/atoms/Divider/index.tsx';

import contentStylesUrl from '~/styles/content/content.css?url';
import stylesUrl from '~/styles/content/pricing.css?url';

export const links: LinksFunction = () => [
	{
		rel: 'stylesheet',
		href: contentStylesUrl,
	},
	{
		rel: 'stylesheet',
		href: stylesUrl,
	},
];

export const meta: MetaFunction = () => [
	{
		title: 'Pricing and packages for GList',
	},
];

type TLoaderData = {
	user: User | null;
	divider: string;
};

// TODO - probably best to add an action here rather than go to a separate buy page... maybe

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const user = await getUser(request);
	const theDivider = divider();
	return {
		user,
		divider: theDivider,
	};
};

export default function Pricing(): React.ReactNode {
	const { user, divider } = useLoaderData<TLoaderData>();

	return (
		<main id="main">
			<Banner title="Convenient pricing plans to suit you" />
			<div
				className="divider white"
				role="img"
				aria-label="Mountain-scape divider"
				aria-hidden="true"
				dangerouslySetInnerHTML={{ __html: divider }}
			/>
			<section className="container pricing-container">
				{renderSwitch(user)}
			</section>
		</main>
	);
}
